<credit-report-layout>
  <app-header></app-header>

  <main class="row">
    <div class="main-content">
      <router-outlet></router-outlet>
    </div>
  </main>
  <opus-message> </opus-message>
</credit-report-layout>
